module.exports = __webpack_public_path__ + "img/pw.462858bb.png";